import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "../styles/Navbar.css";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const scrollToSection = (id) => {
    const pathname = window.location.pathname;

    if (pathname !== "/" && pathname !== "") {
      window.location.href = "/";
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    setIsOpen(false);
  };

  const navigateToPage = (page) => {
    window.location.href = `/${page}`;
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div
          className="logo"
          onClick={() => (window.location.href = "/")}
          style={{ cursor: "pointer" }}
        >
          <h1>Engineer K</h1>
          <p className="tagline">Tech Solutions</p>
        </div>

        <button className="hamburger" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>

        <ul className={`nav-menu ${isOpen ? "active" : ""}`}>
          <li>
            <button
              className="nav-link"
              onClick={() => scrollToSection("hero")}
            >
              Home
            </button>
          </li>

          <li>
            <button
              className="nav-link"
              onClick={() => navigateToPage("software-web-development")}
            >
              Software & Web Development
            </button>
          </li>

          <li>
            <button
              className="nav-link"
              onClick={() => navigateToPage("cybersecurity")}
            >
              Cybersecurity
            </button>
          </li>

          <li>
            <button
              className="nav-link"
              onClick={() => navigateToPage("tech-repair")}
            >
              Tech Repair & Support
            </button>
          </li>

          <li>
            <button
              className="nav-link"
              onClick={() => scrollToSection("portfolio")}
            >
              Portfolio
            </button>
          </li>

          <li>
            <button
              className="nav-link"
              onClick={() => scrollToSection("contact")}
            >
              Contact
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
